module.exports = __webpack_public_path__ + "img/NW08.fa80d177.gif";